var t = require('i18n').t

module.exports = require('./abstract-annual-report').extend({
    api: Em.inject.service(),

    model: function() {
        var model = this.modelFor('annual_report')
        var annualReport = this.get('annualReport')

        return annualReport.getEntriesOnSpecificAccount(7130, model.commitment)
            .then(function(postings) {
                return Em.RSVP.hash(Object.assign({
                    items: annualReport.getControlledTransactionsItems(model.commitment, postings),
                    postingsOn7130Account: postings
                }, model))
            })
    },

    afterModel: function(model) {
        var items = []
        var annualReportService = this.get('annualReport')

        model.items.map(function(item) {
            item.title = t('annual_report.controlled_transactions.' + item.translationKey + '.title')
            items.push(Em.Object.create(item))
        })

        if (model.postingsOn7130Account && model.postingsOn7130Account.length > 0) {
            var answers = [{
                name: 'controlled_transactions.debts_to_and_from_controlled_parties.receivables_from_controlled_parties',
                value: true
            }, {
                name: 'controlled_transactions.debts_to_and_from_controlled_parties.yes_no',
                value: true
            }]

            annualReportService.putAnswer(model.commitment.year, answers)
        }

        this.set('items', items)

        return items
    },

    setupController: function(controller, model, transition) {
        this._super(controller, model, transition)
        controller.set('model', model)
        controller.set('items', model.items)
        controller.set('hasPostingsOn7130Account', model.postingsOn7130Account && model.postingsOn7130Account.length > 0)
    }
})
